// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3J-KB","amount":"Amount_amount__3199F","tip":"Amount_tip__2PTGP","tipHeader":"Amount_tipHeader__1xfyT","tipsWrap":"Amount_tipsWrap__3X0lS"};